module.exports = __webpack_public_path__ + "img/30.de61579f.jpg";